import { useCallback, useMemo } from "react"
import { Knisot } from "../../../../../modules/API/Knisot/knisot"
import { IBomItem } from "../../../../../modules/API/Knisot/models/bom"
import useDataFetcher from "./useFetchData"
import { Defaults } from "../../../../../modules/API/Defaults/defaults"
import { IGetReuqestResponseNode } from "../../../../../modules/API/Defaults/models/pallets"

type Props = {
  product?: {
    ProductID: number
    VarietyID: number
    SizeID?: number
    PackID: number
  }
}

const useWeightCalculation = ({product}: Props) => {
  const {
    data: bom,
    isLoading: isLoadBom
  } = useDataFetcher<IBomItem>(
    Knisot.getBomWeight, `ProductID=${product?.ProductID}&VarietyID=${product?.VarietyID}&SizeID=${product?.SizeID || 0}&PackID=${product?.PackID}`
  )

  const {
    data: palletTypeList
  } = useDataFetcher<IGetReuqestResponseNode>(
    Defaults.getPalletTypes, 'data'
  )

  const calculationWeightWithBom = useCallback((productQty: number) => {
    if(!bom || bom.DF_PackWeigt === 0) return 
    return +(bom.DF_PackWeigt).toFixed(2) * productQty
  }, [bom])

  const calculationWeighNetto = useCallback((weightBrutto: number, palletType: number, palletQty: number) => {
    if(!palletTypeList) return 0
    const pallet = palletTypeList.pallets.find(i => i.Pallete_Type === palletType)
    if(!pallet) return 0
    return +(weightBrutto - pallet.Tare_Weight * (palletQty || 1)).toFixed(2)
  }, [palletTypeList])



  return {
    calculationWeightWithBom,
    isLoadBom,
    palletList: palletTypeList?.pallets || [],
    calculationWeighNetto
  }
}

export default useWeightCalculation